import React from 'react'
import styled from 'styled-components'
import { Image } from '../../common/style/components/image'
import { mobile } from '../../common/style/media-queries'
import exitIcon from './resources/cross.svg'

export const DialogVideo: React.FC<{
  visible: boolean
  videoId: string
  setDialogVideoVisible: (visible: boolean) => void
}> = ({ visible, videoId, setDialogVideoVisible }) => {
  if (!visible) {
    return null
  }

  return (
    <Container>
      <IFrame
        width="85%"
        height="85%"
        src={`https://www.youtube.com/embed/${videoId}?rel=0&amp;showinfo=0;autoplay=1`}
        allowFullScreen
        allow="autoplay"
        frameBorder="0"
      />
      <ExitIcon src={exitIcon} onClick={() => setDialogVideoVisible(false)} />
    </Container>
  )
}

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  background-color: rgba(0, 0, 0, 0.6);

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 50;
`

const ExitIcon = styled(Image)`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`

const IFrame = styled.iframe`
  @media ${mobile} {
    width: auto;
    height: auto;
  }
`
